

import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useLoader from "../../Components/loader/useLoader";
import { baseurl, OnInput, onInputInvalid, successNotify, uploadImage } from "../../constants";


export default function DeleteBusinessOwner() {

  const location = useLocation();
    const row = location.state.row;
    const navigateTo = useNavigate()
    const [loader, showLoader, hideLoader] = useLoader(); 


    const postForm = async () => {
         showLoader()
        const formdata = new FormData()
        formdata.append("businessOwnerId", row.id)


        const response = await fetch(baseurl+"business/delete-BusinessOwner", {
            method: "POST",
            // headers: {

            //     "Authorization": "Bearer " + localStorage.getItem("token")
            // },
            body: formdata
        });

        hideLoader()

        successNotify()

        navigateTo("/admin/BusinessOwners");

    };
 
  return <div>
    {loader}
    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
      <div className="breadcrumb-title pe-3">طلبات الخصم</div>
      <div className="ps-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0 p-0">
            <li className="breadcrumb-item">
              <a href="javascript:;">
                <i className="bx bx-home-alt" />
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">حذف الطلب</li>
          </ol>
        </nav>
      </div>
    </div>
    {/*end breadcrumb*/}
    <hr />
    <div className="col-xl-12 mx-auto">
      <div className="card">
        <div className="card-body">
          <div className="border p-3 rounded">
            <h6 className="mb-0 text-uppercase">معلومات الطلب</h6>
            <hr />
              <div asp-validation-summary="ModelOnly" className="text-danger" />
              <div className="row g-3">
            
              
                <div className="col-6">
                  <label className="form-label"> اسم العميل   </label>
                  <input  disabled  defaultValue={row.firstName}  onInvalid={onInputInvalid }
                        onInput={OnInput} required autoComplete="off" name="Name" type="text" className="form-control" />
                  <span asp-validation-for="Name" className="text-danger" />
                </div>
                <div className="col-6">
                  <label className="form-label"> الاسم الاخير   </label>
                  <input  disabled defaultValue={row.lastName} onInvalid={onInputInvalid }
                        onInput={OnInput} required autoComplete="off" name="NameEn" type="text" className="form-control" />
                  <span asp-validation-for="NameEn" className="text-danger" />
                </div>
              
                {/* <div className="col-6">
                  <label className="form-label">رقم التواصل </label>
                  <input  disabled defaultValue={row.phone} autoComplete="off" name="Phone" type="text" className="form-control" />
                </div>
                <div className="col-6">
                  <label className="form-label">البريد الإلكتروني </label>
                  <input  disabled defaultValue={row.email}  autoComplete="off" name="Email" type="text" className="form-control" />
                </div> */}
              
                {/* <div className="col-6">
                  <label className="form-label">العنوان</label>
                  <input  disabled defaultValue={row.address} autoComplete="off" name="Address" type="text" className="form-control" />
                  <span asp-validation-for="Address" className="text-danger" />
                </div>
                <div className="col-6">
                  <label className="form-label">Latitude</label>
                  <input  disabled  autoComplete="off" defaultValue={row.lat} name="Lat" type="text" className="form-control" />
                </div>
                <div className="col-6">
                  <label className="form-label">Longitude</label>
                  <input  disabled   autoComplete="off" defaultValue={row.lng} name="Lng" type="text" className="form-control" />
                </div> */}

                <div onClick={postForm} class="form-group">
                            <input type="hidden" asp-for="Id" />
                            <input type="submit" value=" تأكيد الحذف" class="btn btn-danger float-right" />
                    </div>
            
             
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

}